const ClipperLib = window['ClipperLib'];
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Curve3, Path3D } from "@babylonjs/core/Maths/math.path";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { LengthProperty, PropertyValue, PropertyChangedResult } from "@egr/wcf/modules/core/prop";
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
export class Road extends ElementGeometry {
    constructor(pRoomManager, pElement, pCurved = false) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mMidPoints = new Array();
        this.mPoints = new Array();
        this.mPointsTMP = new Array();
        this.mCutPoints = new Array();
        this.mSegmentsLength = new Array();
        this.mWidth = 1;
        this.mDepth = 0;
        this.mLength = 0;
        this.mMaterial = 0;
        this.mColor = "#999999";
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mClosedPolygon = false;
        this.mCatMullRom = new Curve3([]);
        this.mSplinePrecision = 10;
        this.mStandardMat = new PbrMaterial("", this.mMatManager);
        this.mStandardMat.albedoColor = Color3.FromHexString("#949494");
        this.mStandardMat.unlit = false;
        this.mStandardMat.freeze();
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
        this.mRoomElement.Params.roadWidth = 1;
        this.mRoomElement.Params.curvedRoad = pCurved;
    }
    getType() {
        return ("Road");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    get drawnMesh() {
        return (this.mMesh2d);
    }
    getPoints() {
        return this.mPoints;
    }
    getMidPoints() {
        this.mMidPoints = [];
        if (this.mRoomElement.curvedRoad()) {
            this.createCatMullRom();
            let tcmPoints = this.mCatMullRom.getPoints();
            for (let i = this.mSplinePrecision * 0.5; i < tcmPoints.length - (this.mSplinePrecision * 0.5 + 1); i += this.mSplinePrecision) {
                this.mMidPoints.push(tcmPoints[i]);
            }
            let tlastIdx = (tcmPoints.length - 1) - (this.mSplinePrecision * 0.5);
            this.mMidPoints.push(tcmPoints[tlastIdx]);
        }
        else {
            for (let i = 0; i < this.mPoints.length - 1; i++) {
                let tmP = Vector3.Center(this.mPoints[i], this.mPoints[i + 1]);
                this.mMidPoints.push(tmP);
            }
            return (this.mMidPoints);
        }
        return (this.mMidPoints);
    }
    getSegmentsLength() {
        return (this.mSegmentsLength);
    }
    getPolygon(pOffset = true) {
        let tpolygonPoints = [];
        let tlinePoints = this.mPoints;
        for (let tP of tlinePoints) {
            let tnodePos = new Vector3(0, 0, 0);
            if (pOffset)
                tnodePos = this.mRoomElement.position.clone();
            let tnP = tP.add(tnodePos);
            tpolygonPoints.push(tnP);
        }
        return (tpolygonPoints);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    correctDirection() {
        let tClockwise = Util._clockWise3(this.mPoints);
        if (tClockwise)
            this.mPoints.reverse();
    }
    correctDirection1() {
        for (let tPolygon of this.mCutPoints) {
            let tClockwise = Util._clockWise3(tPolygon);
            if (tClockwise)
                tPolygon.reverse();
        }
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 1;
        tParams.height = 0.0;
        tParams.floorOffset = 0.0;
        tParams.color = this.mColor;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    getLines() {
        let tRes = new Array();
        for (let i = 0; i < this.mRoomElement.Params.ElementPoints.length - 1; i++) {
            tRes.push([this.mRoomElement.Params.ElementPoints[i], this.mRoomElement.Params.ElementPoints[i + 1]]);
        }
        return (tRes);
    }
    create2dGeometry(pParent) {
        this.mParent = pParent;
        let tLine = this.createRoad(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh2d(tLine);
        }
    }
    create3dGeometry(pParent) {
        let tLine = this.createRoad(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh3d(tLine);
        }
    }
    getProperties() {
        let tProperties = new Array();
        //road width
        let tDepthProp = new LengthProperty(this.mRoomElement, Road.PROP_KEY_ROADWIDTH, this.mRoomManager.resources.propertyWidth);
        tDepthProp.getValue = () => new PropertyValue(this.mRoomElement.Params.roadWidth);
        tDepthProp.setValue = (pValue) => {
            let tValue = LengthProperty.ConvertValueToNumber(pValue);
            if (tValue != null && this.mRoomElement.setRoadWidth(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tDepthProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        this.mRoomElement.Params.roadWidth = tParams.roadWidth;
        this.setPoints(tPoints);
    }
    setPoints(pPoints, pCenter = false) {
        //this.mCutPoints = [];
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection();
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.createCatMullRom();
        this.calcSize();
    }
    deletePoint(pIndex) {
        if (pIndex > this.mPoints.length - 1 || pIndex < 0 || this.mPoints.length === 0 || this.mPoints.length <= 3)
            return;
        this.mPoints.splice(pIndex, 1);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    addPoint(pIndex) {
        let tc1 = pIndex - 1;
        let tc2 = pIndex === this.mPoints.length ? 0 : pIndex;
        let tnewPoint = Vector3.Center(this.mPoints[tc1], this.mPoints[tc2]);
        tnewPoint.x += 0.001;
        tnewPoint.z -= 0.001;
        this.mPoints.splice(pIndex, 0, tnewPoint);
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    setCutPoints(pPoints, pCenter = false) {
        this.mCutPoints = [];
        for (let tarrPoints of pPoints) {
            let tnewPoints = new Array();
            for (let tPoint of tarrPoints) {
                let tP = new Vector3(0, 0, 0);
                tP.x = tPoint.x;
                tP.z = tPoint.z;
                tnewPoints.push(tP);
            }
            this.mCutPoints.push(tnewPoints);
        }
        if (pCenter)
            this.centerPoints(this.mCutPoints);
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection1();
    }
    centerPoints(pPoints) {
        this.mCutPoints = [];
        for (let tpointArr of pPoints) {
            let tnewArr = new Array();
            for (let tPoint of tpointArr) {
                let tnP = Util.to3d(Util.to2d(Vector3.TransformCoordinates(tPoint, this.mRoomElement.transformInverted)));
                tnewArr.push(tnP);
            }
            this.mCutPoints.push(tnewArr);
        }
    }
    checkClosedPolygon() {
        if (this.mPoints.length < 3)
            return;
        this.mClosedPolygon = Util.closedPolygon(this.mPoints);
        this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
    }
    calcCenter() {
        let t2dPoints = new Array();
        for (let tP of this.mPoints)
            t2dPoints.push(new Vector2(tP.x, tP.z));
        let tCenter = new Vector3(0, 0, 0);
        if (this.mPoints.length > 2)
            tCenter = Util.getPolygonCentroid(t2dPoints);
        else {
            tCenter = Vector3.Center(this.mPoints[0], this.mPoints[1]);
        }
        this.mCenter = tCenter;
        this.mCenter = Util.getCenterofPolygon(this.mPoints);
    }
    calcSize() {
        let tPoints = this.mCatMullRom.getPoints();
        if (tPoints.length === 0)
            return;
        let tminX = tPoints[0].x;
        let tminY = tPoints[0].z;
        let tmaxX = tPoints[0].x;
        let tmaxY = tPoints[0].z;
        for (let tPoint of tPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false, false);
        this.mRoomElement.setDepth(this.mDepth, false, false);
        this.mminPoint = new Vector3(tminX, 0, tminY);
        this.mmaxPoint = new Vector3(tmaxX, 0, tmaxY);
    }
    getSegmentsLength_curved(pPoints) {
        this.mSegmentsLength = [];
        this.mLength = 0;
        let tcmPoints = this.mCatMullRom.getPoints();
        if (tcmPoints.length < this.mSplinePrecision)
            return;
        let tPLast = pPoints.length - 1;
        let tPLen = pPoints.length;
        if (Util.samePointsV3(pPoints[tPLast - 1], pPoints[tPLast], 0.000001)) {
            tPLen = pPoints.length - 1;
        }
        for (let x = 0; x < tPLen - 1; x++) {
            let tsegSum = 0;
            let t_start = x * this.mSplinePrecision;
            let t_end = t_start + this.mSplinePrecision;
            for (let i = t_start; i < t_end; i++) {
                let tDist = Vector3.Distance(tcmPoints[i], tcmPoints[i + 1]);
                tsegSum += tDist;
            }
            this.mSegmentsLength.push(tsegSum);
            this.mLength += tsegSum;
        }
        this.mRoomElement.setLength(this.mLength);
    }
    getSegmentsLength_straight(pPoints) {
        this.mSegmentsLength = [];
        this.mLength = 0;
        for (let x = 0; x < pPoints.length - 1; x++) {
            let tDist = Vector3.Distance(pPoints[x], pPoints[x + 1]);
            this.mSegmentsLength.push(tDist);
            this.mLength += tDist;
        }
        this.mRoomElement.setLength(this.mLength);
    }
    createCatMullRom() {
        let ttmpPoints = new Array();
        for (let tP of this.mRoomElement.Params.ElementPoints) {
            let ttmpP = new Vector3(0, 0, 0);
            ttmpP.x = tP.x;
            ttmpP.y = tP.y;
            ttmpP.z = tP.z;
            ttmpPoints.push(ttmpP);
        }
        if (ttmpPoints.length > 2 &&
            (Util.vectorEquals3(ttmpPoints[ttmpPoints.length - 1], ttmpPoints[ttmpPoints.length - 2]))) {
            ttmpPoints.pop();
        }
        this.mCatMullRom = Curve3.CreateCatmullRomSpline(ttmpPoints, this.mSplinePrecision);
    }
    get2dtcatmullRomPoints(pcatMullRom) {
        let tRes = new Array();
        let tPoints = pcatMullRom.getPoints();
        for (let tP of tPoints) {
            tRes.push(new Vector2(tP.x, tP.z));
        }
        return tRes;
    }
    createClosedPolygon(pPoints) {
        let tRes = [];
        if (pPoints.length < 2) {
            return (tRes);
        }
        const tPoints = [];
        for (let tP of pPoints) {
            tPoints.push(new Vector3(tP.x, 0, -tP.y));
        }
        let tPath = new Path3D(tPoints);
        let tnormals = tPath.getNormals().reverse();
        let treverse = tPoints.slice().reverse();
        tRes = tRes.concat(tPoints);
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tnormals.length; i++) {
            tRes.push(treverse[i].add(tnormals[i].scale(0.0001)));
        }
        return (tRes);
    }
    createCAG(poffPoints) {
        if (poffPoints.length === 0) {
            return (null);
        }
        let tarrCAGsides = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < poffPoints.length; i++) {
            // tslint:disable-next-line:prefer-for-of
            for (let j = 0; j < poffPoints[i].length - 1; j++) {
                let tvertex0 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][j].X, poffPoints[i][j].Y));
                let tvertex1 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][j + 1].X, poffPoints[i][j + 1].Y));
                let tCAGside = new CAG.Side(tvertex0, tvertex1);
                tarrCAGsides.push(tCAGside);
            }
            const tlastIdx = poffPoints[i].length - 1;
            let tv0 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][tlastIdx].X, poffPoints[i][tlastIdx].Y));
            let tv1 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][0].X, poffPoints[i][0].Y));
            let tCAGsideClosed = new CAG.Side(tv0, tv1);
            tarrCAGsides.push(tCAGsideClosed);
        }
        let tCAG = CAG.fromSides(tarrCAGsides);
        tCAG.isCanonicalized = true;
        return (tCAG);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createRoad(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        this.createCatMullRom();
        let tmullPoints = Util.to3dArray(this.get2dtcatmullRomPoints(this.mCatMullRom));
        this.mPointsTMP = [];
        for (let tP of this.mPoints) {
            let tPx = tP.x;
            let tPy = -tP.z;
            this.mPointsTMP.push(new Vector3(tPx, tPy, 0));
        }
        // remove last point if it's equal to the 1st one
        if ((this.mPointsTMP.length > 2) &&
            (Util.vectorEquals3(this.mPointsTMP[this.mPointsTMP.length - 2], this.mPointsTMP[this.mPointsTMP.length - 1]))) {
            this.mPointsTMP.pop();
        }
        if (this.mRoomElement.curvedRoad() && this.mPointsTMP.length > 2) {
            this.getSegmentsLength_curved(this.mRoomElement.Params.ElementPoints);
            this.mPointsTMP = [];
            for (let tP of tmullPoints) {
                let tPx = tP.x;
                let tPy = tP.z * -1;
                this.mPointsTMP.push(new Vector3(tPx, tPy, 0));
            }
        }
        else {
            this.getSegmentsLength_straight(this.mRoomElement.Params.ElementPoints);
        }
        const tclosedPoly = this.createClosedPolygon(this.mPointsTMP);
        if (tclosedPoly.length < 4) {
            return (null);
        }
        let toffsetPoints = createOffsetPolygon(this.mPointsTMP, this.mRoomElement.Params.roadWidth * 0.5, this.mClosedPolygon);
        let tCAG = this.createCAG(toffsetPoints);
        if (tCAG == null) {
            return (null);
        }
        let tCSGBase = Util.CAG2CSG(tCAG, this.mRoomElement.height);
        let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Hedge', tCSGBase, this.mRoomElement.localMaterial);
        if (tMeshes_base == null) {
            return (null);
        }
        this.mRoomElement.setCAG(tCAG);
        this.mRoomElement.setCAG_notVisible(tCAG);
        this.prepare3dMesh(tMeshes_base[0]);
        return (tMeshes_base[0]);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Road.PROP_KEY_ROADWIDTH = "room:RoomElement:roadwidth";
function createOffsetPolygon(polygon, spacing, pclosed) {
    const geoInput = vectorCoordinates2Clipper(polygon);
    ClipperLib.JS.ScaleUpPath(geoInput, ElementGeometry.CLIPPER_SCALING_VALUE);
    let clipperOffset = new ClipperLib.ClipperOffset(ElementGeometry.CLIPPER_MITER_LIMIT, 100);
    let tPath = new ClipperLib.Path();
    for (let tP of geoInput) {
        tPath.push(tP);
    }
    let tending = ClipperLib.EndType.etOpenButt;
    if (pclosed) {
        tending = ClipperLib.EndType.etClosedLine;
    }
    clipperOffset.AddPath(tPath, ClipperLib.JoinType.jtMiter, tending);
    let tPaths = new ClipperLib.Paths();
    clipperOffset.Execute(tPaths, spacing * ElementGeometry.CLIPPER_SCALING_VALUE);
    let solution = new ClipperLib.Paths();
    if (tPaths.length > 1) {
        let subj = new ClipperLib.Paths();
        let clips = new ClipperLib.Paths();
        let ttmpPaths = tPaths.slice();
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < ttmpPaths.length; i++) {
            ttmpPaths[i].push(ttmpPaths[i][0]);
        }
        subj.push(tPaths[0]);
        for (let i = 1; i < tPaths.length; i++) {
            clips.push(tPaths[i]);
        }
        let c = new ClipperLib.Clipper();
        c.AddPaths(subj, ClipperLib.PolyType.ptSubject, true);
        c.AddPaths(clips, ClipperLib.PolyType.ptClip, true);
        c.Execute(ClipperLib.ClipType.ctDifference, solution);
        tPaths = solution;
    }
    ClipperLib.JS.ScaleDownPaths(tPaths, ElementGeometry.CLIPPER_SCALING_VALUE);
    return (tPaths);
}
function vectorCoordinates2Clipper(tPoints) {
    return tPoints.map((point) => new ClipperLib.IntPoint(point.x, -point.y));
}
